import { IconButton, Tooltip } from "@material-ui/core"
import CompareIcon from '@material-ui/icons/Compare';
import { useDispatch } from "react-redux";
import { openEnmascararPaqueteAction } from "../../../ducks/proveedorTerrestreDuck";

const BMayorista = (props) => {
    const { paquete } = props
    const dispatch = useDispatch()

    const handleClick = () => {
        dispatch(openEnmascararPaqueteAction({
            paquete
        }))
    } 
    
    return (
        <Tooltip title="Configurar mayorista">
            <IconButton aria-label="Declinar solicitud" onClick={handleClick}>
                <CompareIcon color="primary" />
            </IconButton>
        </Tooltip>
    )
}
export default BMayorista